import { createFileRoute } from "@tanstack/react-router";
import { seo, seoLinks } from "~/utils/seo";
import { PricingHosting } from "~/components/pricing/PricingHosting";
import { FinalCta } from "~/components/pricing/FinalCta";

export const Route = createFileRoute("/pricing/hosting")({
  loader: () => ({}),
  head: () => ({
    meta: seo({
      title: "C1 hosting availability — Pricing | C1",
      description:
        "C1 Commercial US and Commercial EU hosting are available now. Review both environments, plus the planned Federal environment.",
      url: "/pricing/hosting/",
    }),
    links: seoLinks({ url: "/pricing/hosting/" }),
  }),
  component: HostingPage,
});

function HostingPage() {
  return (
    <>
      <PricingHosting />
      <FinalCta />
    </>
  );
}
